import * as $ from 'jquery';

function tableOfContents() {
	if (!document.querySelector('.toc--enabled')) {
		// Not enabled
		return;
	}

	// When calculating what we consider in view, we need to offset since the sticky nav hides the top of the page
	const offset = 30;

	// Find all anchors
	const anchors = document.querySelectorAll("[data-toc-anchor-label]");
	if (anchors.length === 0) {
		// Do not include TOC. (If only one we don't include since very odd if we do)
		return;
	}

	// Ingest the TOC template using template included in the page
	const tocTemplate = $('#tmpl-table-of-contents').html();
	const $toc = $(tocTemplate);
	$('header.pageHeading').after($toc);

	// add data attribute to page heading for overlay graphic BG
	document.body.classList.toggle('has-table-of-contents', true);

	// Create LIs
	const ul = $toc.find('.table-of-contents__nav')[0];
	for (const node of anchors) {
		const id = node.getAttribute('id');
		const label = node.getAttribute('data-toc-anchor-label') ?? "";
		const li = document.createElement('LI');
		const a = document.createElement('A');
		a.setAttribute('href', '#' + id);
		a.innerText = label;
		li.append(a);
		li.id = `toc-${id}`;
		ul.append(li);
	}

	// ------------------------------
	// Scroll Match
	// ------------------------------
	const updateTOC = () => {
		let bestDelta = -Infinity;
		let best: string|null = null;
		const innerHeight = window.innerHeight - offset;
		const middleHeight = innerHeight / 2;

		for (const node of anchors) {
			const rect = (node instanceof HTMLAnchorElement ? node.parentElement! : node).getBoundingClientRect();
			const top = rect.top - offset;
			if (top < innerHeight) {
				if (rect.bottom > 0) {
					const delta = top - middleHeight;
					if (delta < 0 && delta > bestDelta) {
						bestDelta = delta;
						best = node.id;
					}
				}
			} else {
				break;
			}
		}

		const newActive = best !== null ? document.getElementById(`toc-${best}`)?.querySelector('a') : null;

		const active = ul.querySelector('a.active');
		if (active && active !== newActive) {
			active.classList.toggle('active', false);
		}
		if (newActive) {
			newActive.classList.toggle('active', true);
		}
	}

	updateTOC();

	let timeoutId: any = null;
	document.addEventListener('scroll', () => {
		if (timeoutId) {
			clearTimeout(timeoutId);
		}
		timeoutId = setTimeout(updateTOC, 50);
	});

	// add 'is-sticky' class to TOC when element is pinned to top of window (need this for the Appointment button)
	const getTableOfContentsElem = document.querySelector(".table-of-contents");
	if(getTableOfContentsElem) {
		new IntersectionObserver(
			entries => entries.forEach(e => e.target.classList.toggle("is-sticky", e.intersectionRatio < 1)),
			{ threshold: [1] }
		).observe(getTableOfContentsElem);
	}
}

$(() => tableOfContents());
